export default "<st-team-notification team=\"$ctrl.teamInfo\" user=\"$ctrl.userInfo\" roles=\"$ctrl.roleInfo\" mode=\"$ctrl.mode\"></st-team-notification>";